/*
*@Author: qinlili
*@Date: 2019/4/22
*@Version: 1.0
 * @Last Modified by: qinlili.qll
 * @Last Modified time: 2022-03-09 11:35:16
*/
import batchHandleUrl from '../../../../utils/url-handle'

let api = {
  // 获取所有的省
  getCityTree: {
    url: '/purchaser/mall/city/getCityTree',
    type: 'get'
  }
}
export default batchHandleUrl(api)
